import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/BouwInvest-Frontend/src/app/not-found.tsx");
